/* eslint-disable import/no-cycle */
import Dialog from "@mui/material/Dialog";
import * as React from "react";
import { applicationInfoType } from "types/app";
import AppName from "./AppName";
import OrganizationName from "./OrganizationName";
import { getCompanyInfo } from "@/redux/organization/selector";
import { useSelector } from "react-redux";
import Loader from "@/components/Loader";

interface IRegisterDialogProps {
	setApplicationInfo: (value: applicationInfoType[]) => void;
}

const RegisterDialog: React.FC<IRegisterDialogProps> = ({ setApplicationInfo }) => {
	const companyInfo = useSelector(getCompanyInfo);
	const [activeStep, setActiveStep] = React.useState(-1);
	const [dialogOpen, setDialogOpen] = React.useState(true);

	const selectStepFunc = (organizationName: string, appCount: number) => {
		if (organizationName === "" && appCount === 0) {
			// organization Body화면
			setActiveStep(0);
		} else if (organizationName !== "" && appCount === 0) {
			// Appname Body화면
			setActiveStep(1);
		}
	};

	React.useEffect(() => {
		if (companyInfo !== null) {
			selectStepFunc(companyInfo.name, companyInfo.appCount);
		}
	}, [companyInfo]);

	if (!companyInfo) {
		return <Loader />;
	}

	return (
		<Dialog
			aria-labelledby="simple-dialog-title"
			// onClose={(event, reason) => {
			// 	if (reason !== "backdropClick") {
			// 		handleModalClose();
			// 	}
			// }}
			open={companyInfo.isFirstMakeApp && dialogOpen}
			fullWidth={true}
		>
			{activeStep === 0 ? (
				<OrganizationName setActiveStep={setActiveStep} activeStep={activeStep} />
			) : (
				<AppName
					activeStep={activeStep}
					setApplicationInfo={setApplicationInfo}
					setDialogOpen={setDialogOpen}
				/>
			)}
		</Dialog>
	);
};
export default RegisterDialog;
